import { render, staticRenderFns } from "./quick-add.vue?vue&type=template&id=e40515d4&scoped=true&"
import script from "./quick-add.vue?vue&type=script&lang=js&"
export * from "./quick-add.vue?vue&type=script&lang=js&"
import style0 from "./quick-add.vue?vue&type=style&index=0&id=e40515d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40515d4",
  null
  
)

export default component.exports